import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';
import Footer from './footer.jsx';
import Header from './header.jsx';
import RankedDisplayWidget from "./rankedDisplayWidget.jsx"
const { getAllowCookies } = require('./../cookieUtils');

const MAX_NAME = 40;

class MainView extends React.Component {

    constructor() {
        super();

        this.state = {
            name: "",
        }
    }

    handleChange(event) {

        this.setState({
            name: event.target.value.substring(0, MAX_NAME).replace("\n", "").trim(),
        });
    }

    clickFind() {
        this.props.clickFind(this.state.name || this.props.defaultName);
    }

    clickRanked() {
        this.props.clickFindRanked(this.state.name || this.props.defaultName);
    }

    clickCustom() {
        this.props.clickCustom(this.state.name || this.props.defaultName);
    }   

    clickLowerRight() {
        this.props.clickBottomRight(this.state.name || this.props.defaultName);
    }   

    genName() {
        if (this.props.canEditName) {
            return (  
                <div>
                    Nickname:<br/>
                    <input value={ this.state.name } onChange={this.handleChange.bind(this)} 
                        autocomplete="off" type="text" id="name" placeholder={ this.props.defaultName }></input>
                    <div class="nameInst">
                        Make it cool and unique. Don't use your real name.
                    </div>
                    <br/>
                </div>
            );//'
        } else {

            return (
                <h3>
                    { this.props.defaultName }
                </h3>
            );
        }
    }

    clickLeaders() {
        this.props.clickLeaders(this.state.name || this.props.defaultName);
    }

    clickTutorial() {
        this.props.clickTutorial(this.state.name || this.props.defaultName);
    }

	render() {
        return (
            <div class="main" id="main">
                <canvas id="backCanvas" class="backCanvas"></canvas>
                <Header shouldShowRedirect={this.props.shouldShowRedirect}/>

                <div class="middle" id="nickname">
                    <h3>
                        
                        { this.genName() }

                        <button onClick={this.clickFind.bind(this)} id="go">Find Game</button>
                        <div class="vPadding"></div>
                        <button onClick={this.clickCustom.bind(this)} class="button2">Custom Game</button>

                        <div class="vPadding"></div>
                        {
                            getAllowCookies() &&
                            <button onClick={this.clickRanked.bind(this)} class="button3">Find Ranked 1v1</button>
                        }
                        {
                            !getAllowCookies() &&
                            <div class="rankedHover">
                                <button class="button3dead">Find Ranked 1v1</button>
                                <span class="rankedHoverText">
                                    Ranked mode require a cookie to save your ranked data.<br/>
                                    Enable through our Cookie Preferences (lower right)
                                </span>
                            </div>
                        }
                        <div class="newRankedFeatures">
                            Custom Game Settings >>
                        </div>
                    </h3>
                </div>

                <Footer clickTutorial={this.clickTutorial.bind(this)} clickLeaders={this.clickLeaders.bind(this)} clickBottomRight={this.clickLowerRight.bind(this)} 
                    bottomRightMessage={this.props.bottomRightMessage} clickPrivacySettings={this.props.clickPrivacySettings}/>

                <RankedDisplayWidget rank={0} score={0}/>
            </div>
        );
	}
}

MainView.propTypes = {
    canEditName: PropTypes.bool,
    clickFind: PropTypes.func,
    clickCustom: PropTypes.func,
    clickBottomRight: PropTypes.func,
    bottomRightMessage: PropTypes.string,
    clickTutorial: PropTypes.func,
    defaultName: PropTypes.string,
    shouldShowRedirect: PropTypes.bool,
    clickLeaders: PropTypes.func,
    clickFindRanked: PropTypes.func,
};

export default MainView;